import React, { useCallback, useMemo } from 'react';

import { useAppDispatch } from '../../../../hooks/react-redux';
import { Button } from '../../../shared/button/Button';
import styles from './Theoretical.module.scss';
import { NettingEngineSurvey, updateNettingEngineData, setShowSummary, setIsChangingQuestion, ISDANettingEngineData } from '../store';

interface TheoreticalBooleanQuestionsProps {
    surveyQuestionIndex: number;
    nettingEngineSurvey: NettingEngineSurvey[];
    transitionToQuestionByIncrement: (increment?: number) => void
    transitionToNextQuestion: () => void;
}

export const TheoreticalBooleanQuestions: React.FC<TheoreticalBooleanQuestionsProps> = ({
    surveyQuestionIndex,
    nettingEngineSurvey,
    transitionToQuestionByIncrement,
    transitionToNextQuestion
}) => {
    const dispatch = useAppDispatch();

    const updateBooleanAnswer = useCallback((value: boolean, key: keyof ISDANettingEngineData) => {
        dispatch(updateNettingEngineData(key, value));
        dispatch(setIsChangingQuestion(true));
        if (key === 'productTypesKnown' && !value) {
            transitionToQuestionByIncrement(2);
        } else if (key === 'counterpartyIsMultiBranch' && !value) {
            dispatch(setShowSummary(true));
        } else {
            transitionToNextQuestion();
        }
    }, [dispatch, transitionToNextQuestion, transitionToQuestionByIncrement]);

    const { key } = nettingEngineSurvey[surveyQuestionIndex];

    const surveyNote = useMemo(() => {
        if (surveyQuestionIndex === 5) {
            return 'Note: if you select "No", we will return a synopsis of all products in Ark 51 from the perspective of close-out netting.';
        }
        if (surveyQuestionIndex === 7) {
            return 'Note: if you select "No", it will be assumed that the counterparty is operating from an office in the jurisdiction of its incorporation.';
        }
        return '';
    }, [surveyQuestionIndex]);

    return (
        <>
            <div className={styles.surveyButtonWrapper}>
                <Button label='Yes' onClick={() => updateBooleanAnswer(true, key)} />
                <Button label='No' onClick={() => updateBooleanAnswer(false, key)} />
            </div>
            <div className={styles.surveyMessage}>{surveyNote}</div>
        </>
    );
};
